import { ApnsCommand, ApnsCommandData, ApnsCommandHelper } from "./apns-command";
import { DcoOperationCommand, DcoOperationCommandData, DcoOperationCommandHelper } from "./dco-operation-command";
import { DcoPropertyCommand, DcoPropertyCommandData, DcoPropertyCommandHelper } from "./dco-property-command";
import { EmailCommand, EmailCommandData, EmailCommandHelper } from "./email-command";
import { SceneCommand, SceneCommandData, SceneCommandHelper } from "./scene-command";
import { ServiceOperationCommand, ServiceOperationCommandData, ServiceOperationCommandHelper } from "./service-operation-command";
import { ServicePropertyCommand, ServicePropertyCommandData, ServicePropertyCommandHelper } from "./service-property-command";
import { WaitTimeCommand } from "./waittime-command";

export {
    DcoOperationCommandHelper,
    DcoPropertyCommandHelper,
    ServiceOperationCommandHelper,
    ServicePropertyCommandHelper,
    EmailCommandHelper,
    ApnsCommandHelper,
    SceneCommandHelper,
};

export type CommandType =
    | DcoOperationCommand
    | DcoPropertyCommand
    | ServiceOperationCommand
    | ServicePropertyCommand
    | EmailCommand
    | ApnsCommand
    | SceneCommand
    | WaitTimeCommand;

export type CommandTypeData =
    | DcoOperationCommandData
    | DcoPropertyCommandData
    | ServiceOperationCommandData
    | ServicePropertyCommandData
    | EmailCommandData
    | ApnsCommandData
    | SceneCommandData;
